// @ts-expect-error Typescript library is in beta. When it is in stable we will replace this
import AddSearchClient from "addsearch-js-client";
import { isNotUndefinedOrNull } from "../../../FunctionsCore";
const initAddSearchClient = ({ addSearchPublicSiteKey, pageNumber, resultsPerPage }) => {
    const client = new AddSearchClient(addSearchPublicSiteKey);
    client.addFacetField("custom_fields.category");
    client.addFacetField("custom_fields.contentType");
    client.addFacetField("custom_fields.businessType");
    client.setPaging(pageNumber, resultsPerPage, "relevance", "desc");
    return client;
};
const getSiteContentAddSearch = ({ addSearchClient, filterObject, handleSearchResults, resultsPerPage, searchTerm }) => {
    // @ts-expect-error Typescript library is in beta. When it is in stable we will replace this
    addSearchClient.setFilterObject(filterObject);
    const searchResult = new window.Promise((resolve) => {
        // @ts-expect-error Typescript library is in beta. When it is in stable we will replace this
        addSearchClient.search(searchTerm, resolve);
    });
    searchResult.then((response) => {
        // @ts-expect-error Typescript library is in beta. When it is in stable we will replace this
        const facetsByPageCategory = window.Object.entries(response.facets).flatMap(resourceType => {
            const resourceTypeName = resourceType[0];
            // @ts-expect-error Typescript library is in beta. When it is in stable we will replace this
            return response.facets[resourceType[0]].map(facet => ({
                "count": facet.count,
                "name": facet.value,
                "resourceType": `${resourceTypeName}=${facet.value}`
            }));
        });
        // @ts-expect-error Typescript library is in beta. When it is in stable we will replace this
        const siteContentCards = response.hits.map((hit, idx) => ({
            "contentType": isNotUndefinedOrNull(hit.custom_fields) && typeof hit.custom_fields.contentType !== "undefined" ? hit.custom_fields.contentType : "undefined",
            "description": hit.meta_description,
            "documentId": hit.id,
            "href": hit.url,
            "imageName": "https://www.dnb.com/content/dam/english/image-library/Modernization/dual-image/hero-dnb-lockup-blue.gif",
            // @ts-expect-error Typescript library is in beta. When it is in stable we will replace this
            "position": (idx + 1) + ((window.Number(response.page) - 1) * window.Number(resultsPerPage)),
            "title": hit.title
        }));
        return {
            "facetsByPageCategory": facetsByPageCategory,
            "keyword": searchTerm,
            // @ts-expect-error Typescript library is in beta. WHen it is in stable we will replace this
            "returnResults": response.hits.length,
            "siteContentCards": siteContentCards,
            // @ts-expect-error Typescript library is in beta. WHen it is in stable we will replace this
            "totalMatchedResults": response.total_hits
        };
    }).then(handleSearchResults);
};
const sendClickEventAddSearch = ({ addSearchClient, addSearchResultInfo }) => {
    const { documentId, keyword, position } = addSearchResultInfo;
    // @ts-expect-error Typescript library is in beta. When it is in stable we will replace this
    addSearchClient.sendStatsEvent("click", keyword, { "documentId": documentId, "position": position });
};
export { getSiteContentAddSearch, initAddSearchClient, sendClickEventAddSearch };
